import { useState, useEffect } from "react";

import { v4 as uuidv4 } from "uuid";

import classnames from "classnames";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  updateDoc,
  addDoc,
} from "firebase/firestore";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft, FaReply } from "react-icons/fa";
import { Button, Modal, ModalBody } from "reactstrap";

import { useTranslation } from "react-i18next";
import { IoClose } from "react-icons/io5";

function ChatRoomPage() {
  const { t } = useTranslation("common");

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const [user] = useAuthState(auth);

  const [userUsername, setUserUsername] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();

      setUserUsername(data.username);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  const navigate = useNavigate();

  const params = useParams();
  const roomUid = params.roomUid;

  const [chatRoom, setChatRoom] = useState();
  const fetchChatRoom = async () => {
    try {
      setIsLoading(true);

      const q = query(
        collection(db, "chatRooms"),
        where("roomUid", "==", roomUid)
      );
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      if (data) {
        data.messages.reverse();
        setChatRoom(data);
      } else {
        const newChatRoom = {
          roomUid,
          messages: [],
        };

        await addDoc(collection(db, "chatRooms"), newChatRoom);

        setChatRoom(newChatRoom);
      }

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching chat room");
    }
  };

  useEffect(
    () => {
      if (roomUid) {
        fetchChatRoom();
      }
    },
    // eslint-disable-next-line
    [roomUid]
  );

  const [message, setMessage] = useState();

  const postMessage = async () => {
    setIsLoading(true);

    const q = query(
      collection(db, "chatRooms"),
      where("roomUid", "==", roomUid)
    );
    const doc = await getDocs(q);
    // eslint-disable-next-line
    const data = doc.docs[0]?.data();

    const newMessage = {
      uid: uuidv4(),
      posterName: userUsername,
      posterUid: user.uid,
      message,
      timestamp: new Date().getTime(),
    };

    let newMessages = data.messages;

    if (newMessages.length > 0) {
      newMessages.push(newMessage);
    } else {
      newMessages = [newMessage];
    }

    await updateDoc(doc.docs[0].ref, {
      messages: newMessages,
    });

    fetchChatRoom();

    setMessage("");

    setIsLoading(false);
  };

  const [postThreadModalIsOpen, setPostThreadModalIsOpen] = useState(false);
  const [postForModal, setPostForModal] = useState();
  const togglePostThreadModal = (message) => {
    if (message) {
      setPostForModal(message);
    }
    setPostThreadModalIsOpen(!postThreadModalIsOpen);
  };

  const [postReply, setPostReply] = useState();

  const replyToPost = async () => {
    try {
      setIsLoading(true);

      const q = query(
        collection(db, "chatRooms"),
        where("roomUid", "==", roomUid)
      );
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      const newMessages = data.messages;

      newMessages.forEach((message) => {
        if (message.uid === postForModal.uid) {
          if (message.replies) {
            message.replies.push({
              uid: uuidv4(),
              posterName: userUsername,
              posterUid: user.uid,
              message: postReply,
              timestamp: new Date().getTime(),
            });
          } else {
            message.replies = [
              {
                uid: uuidv4(),
                posterName: userUsername,
                posterUid: user.uid,
                message: postReply,
                timestamp: new Date().getTime(),
              },
            ];
          }
        }
      });

      await updateDoc(doc.docs[0].ref, {
        messages: newMessages,
      });

      fetchChatRoom();
      setPostReply("");
      togglePostThreadModal();

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while replying to post");
    }
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="chatRoomPage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        CHAT
      </h1>
      <div id="chatContainer">
        {chatRoom?.messages?.length > 0 ? (
          chatRoom?.messages?.map((message) => {
            return (
              <div
                className={classnames(
                  {
                    ownMessage: message?.posterUid === user?.uid,
                  },
                  {
                    othersMessage: message?.posterUid !== user?.uid,
                  },
                  "chatRoomMessage"
                )}
              >
                <p className="chatRoomMessagePoster">{message.posterName}</p>
                <p
                  style={{
                    marginBottom: message.replies?.length > 0 && "0.5rem",
                  }}
                >
                  {message.message}
                </p>
                {message.replies?.length > 0 &&
                  message.replies.map((reply) => {
                    return (
                      <div
                        className={classnames(
                          {
                            ownMessage: reply?.posterUid === user?.uid,
                          },
                          {
                            othersMessage: reply?.posterUid !== user?.uid,
                          },
                          "chatRoomMessage"
                        )}
                      >
                        <p className="chatRoomMessagePoster">
                          {reply.posterName}
                        </p>
                        <p>{reply.message}</p>
                      </div>
                    );
                  })}
                <p
                  onClick={() => togglePostThreadModal(message)}
                  className="messageReplyBtn"
                >
                  {t("reply")} <FaReply />
                </p>
              </div>
            );
          })
        ) : (
          <p
            style={{ color: "#FFFFFF", marginTop: "1rem", textAlign: "center" }}
          >
            {t("thereAreNoPostsYet")}
          </p>
        )}
        <Modal
          id="walletModal"
          isOpen={postThreadModalIsOpen}
          toggle={togglePostThreadModal}
          size={"lg"}
        >
          <ModalBody>
            <div className="modalHeader">
              <div></div>
              <IoClose onClick={togglePostThreadModal} />
            </div>
            <div>
              <h1>POST</h1>
              <div style={{ marginTop: "1rem" }}>
                <div
                  className="chatRoomMessage ownMessage"
                  style={{ marginBottom: "1rem" }}
                >
                  <p className="chatRoomMessagePoster">
                    {postForModal?.posterName}
                  </p>
                  <p>{postForModal?.message}</p>
                </div>
                <div style={{ display: "flex" }}>
                  <input
                    type="text"
                    className="mainInput"
                    value={postReply}
                    onChange={(e) => setPostReply(e.target.value)}
                    placeholder={t("typeAMessage")}
                  />
                  <Button
                    onClick={replyToPost}
                    className="primaryBtn"
                    style={{ width: "min-content", marginLeft: "0.5rem" }}
                    disabled={!postReply}
                  >
                    {t("reply").toUpperCase()}
                  </Button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
      <div id="chatRoomInputContainer">
        <input
          type="text"
          className="mainInput"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder={t("typeAMessage")}
        />
        <Button
          onClick={postMessage}
          className="primaryBtn"
          style={{ width: "min-content" }}
          disabled={!message}
        >
          {t("post").toUpperCase()}
        </Button>
      </div>
    </div>
  );
}

export default ChatRoomPage;
